// Seedable RNG (00-architecture.md §3): src/game/ never calls Math.random().

/** Returns a number in [0, 1). */
export type Rng = () => number;

/**
 * Weighted pick over percent weights, ported from `SpawnPointSpawnBug` and
 * shared with the power-up slot roll (`AddPowerUp2`, `BugsModel.cs:1816-1827`):
 * roll an integer in [0, 100) and walk the cumulative intervals, taking the
 * first that contains it. Weights summing to < 100 leave a gap at the top, and
 * a roll landing in it picks nothing — `null`.
 */
export function pickWeightedIndex(rng: Rng, weights: readonly number[]): number | null {
  const r = Math.floor(rng() * 100);
  let upper = 0;
  for (let i = 0; i < weights.length; i++) {
    const lower = upper;
    upper += weights[i];
    if (lower <= r && r < upper) return i;
  }
  return null;
}

/** Standard mulberry32 — 32-bit state, fast, good enough for gameplay. */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
